<template>
    <div>
        <span v-if="!params.node.rowPinned">
            <div v-if="isSubscriptionPayment">
                <div>&nbsp;</div>
                <div v-for="sp in data.split_payments">
                    {{ sp[1] }}
                </div>
            </div>
            <div>({{ data.amount }})</div>
        </span>
        <span v-if="params.node.rowPinned">
            <div>
                <b>{{ totalAmount }}</b>
            </div>
        </span>
    </div>
</template>

<script>
import { toAmountDisplay } from '../../../../utils/numbers';

export default {
    computed: {
        isSubscriptionPayment() {
            return this.data.payment_type == 'SUBSCRIPTION';
        },
        isVerification() {
            return this.data.payment_type == 'VERIFICATION';
        },
        totalAmount() {
            return toAmountDisplay({
                amount: this.data.amount,
                currency: '$',
            });
        },
    },
    created() {
        this.data = this.params.data;
    },
};
</script>
